export default __webpack_public_path__ + "static/media/kwicktable-logo.9760d3e6.png";